<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>开通产品</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">选手信息</span>
        </el-col>
      </el-row>
      <el-form
        :model="userForm"
        class="filter_Form"
        label-width="90px"
        ref="userFormRef"
      >
        <el-row :gutter="30">
          <el-col :span="8">
            <el-form-item label="姓名" prop="userName">
              <el-input v-model="userForm.userName" placeholder="请输入" clearable ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="userForm.phone" placeholder="请输入" clearable ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="text-align: right;">
            <el-button type="primary" @click="searchUser">查询</el-button>
            <el-button type="primary" plain @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-row v-if="isBasicInfoComplete">
        <el-col :span="8" v-for="(value, key) in userInfo" :key="key">
          <div class="basic-info">
            <span class="key">{{key}}：</span>{{value}}
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">产品信息</span>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick" v-if="isBasicInfoComplete">
        <el-tab-pane label="Step1 选择产品" name="0">
          <el-form
            :model="pForm"
            class="filter_Form"
            label-width="90px"
          >
            <el-row :gutter="30">
              <el-col :span="13">
                <el-form-item label="产品" prop="productId">
                  <el-select style="display: inline-block; width: 100%;"
                    placeholder="请选择"
                    v-model="pForm.productId"
                    clearable
                    @change="onChange"
                  >
                    <el-option
                      v-for="item in productList"
                      :key="item.id"
                      :label="item.productName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-row v-if="pForm.productId && list.length" style="width: 900px;">
            <el-col :span="24">
              <el-row class="thead">
                <el-col :span="12" class="col" style="padding-left: 66px;">项目</el-col>
                <el-col :span="6" class="col" style="padding-left: 70px;">数量</el-col>
                <el-col :span="6" class="col" style="padding-left: 116px;">价格</el-col>
              </el-row>
              <div class="list-item" v-for="item of list" :key="item.id">
                <el-row>
                  <el-col :span="12">
                    <el-checkbox class="list-item-checkbox" v-model="item.checked" @change="checkChange">{{ item.tproductName }}</el-checkbox>
                  </el-col>
                  <el-col :span="6" style="text-align: center;">
                    <el-input-number class="price-num" size="small" v-model="item.num" :disabled="!item.checked" :min="1" @change="numChange" label="数量"></el-input-number>
                  </el-col>
                  <el-col :span="6">
                    <div class="list-item-price">
                      ¥ <el-input class="price-input" v-model="item.price" @input="priceChange" :disabled="!item.checked" placeholder="请输入价格"></el-input>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="total">费用合计：¥ {{ totalPrice }}</div>
              <div class="submit">
                <el-button type="primary" class="btn" @click="nextFn">下一步</el-button>
              </div>
            </el-col>
          </el-row>
          <div class="default" v-if="pForm.productId && !list.length">暂无产品信息</div>
        </el-tab-pane>
        <el-tab-pane label="Step 2 完善开通信息" name="1" :disabled="!list.length">
          <el-form
            :model="openForm"
            :rules="openFormRules"
            class="filter_Form"
            label-width="110px"
            ref="openFormRef"
          >
          <el-row>
            <el-col :span="8">
              <el-form-item label="赛季" prop="season">
                <el-select
                  placeholder="请选择"
                  style="width: 220px"
                  v-model="openForm.season"
                >
                  <el-option
                    v-for="item in dict_season"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单来源" prop="orderSource">
                <el-select
                  placeholder="请选择"
                  style="width: 220px"
                  v-model="openForm.orderSource"
                >
                  <el-option
                    v-for="item in order_source"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单状态" prop="orderStatus">
                <el-select
                  placeholder="请选择"
                  style="width: 220px"
                  v-model="openForm.orderStatus"
                  disabled
                >
                  <el-option
                    v-for="item in order_status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <template v-if="openForm.orderStatus === '2'">
              <el-col :span="16">
                <el-form-item label="邮寄省市区">
                  <el-cascader
                    placeholder="请选择"
                    v-model="area"
                    ref="areaRef"
                    :options="areasData"
                    style="width: 90%"
                    :props="{
                      expandTrigger: 'hover',
                      label: 'name',
                      value: 'id',
                      children: 'areas',
                    }"
                    @change="provincesHandleChange()"
                  ></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="详细地址">
                  <el-input style="width: 220px" v-model="openForm.nationalAddressDTO.receiptAddress" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
            </template>
            <el-col :span="8">
              <el-form-item label="订单总额" prop="orderAmount">
                <el-input style="width: 220px" v-model="openForm.orderAmount" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="实付金额" prop="paymentAmount">
                <el-input style="width: 220px" v-model="openForm.paymentAmount" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="优惠金额" prop="discountAmount">
                <el-input style="width: 220px" v-model="openForm.discountAmount" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="下单时间" prop="orderTime">
                <el-date-picker
                  v-model="openForm.orderTime"
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="支付时间" prop="endTime">
                <el-date-picker
                  v-model="openForm.endTime"
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="订单完成时间" prop="closeTime">
                <el-date-picker
                  v-model="openForm.closeTime"
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="交易流水号" prop="transactionId">
                <el-input style="width: 220px" v-model="openForm.transactionId" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="IP地址" prop="ip">
                <el-input style="width: 220px" v-model="openForm.ip" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注" prop="remark">
                <el-input style="width: 220px" v-model="openForm.remark" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="支付方式" prop="payPlatform">
                <el-radio-group v-model="openForm.payPlatform">
                  <el-radio :label="radio.value" :key="radio.value" v-for="radio of pay_way">{{radio.label}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="submit">
          <el-button type="primary" plain class="btn" @click="prevFn">上一步</el-button>
          <el-button type="primary" class="btn" @click="showOpenConfirm">开 通</el-button>
        </div>
        </el-tab-pane>
      </el-tabs>
      <div class="default" v-if="!isBasicInfoComplete">
        <el-empty description="请查询选手信息后，再选择产品"></el-empty>
      </div>
    </el-card>
    <el-dialog
      title="确认开通信息"
      :visible.sync="openConfirm"
      width="70%">
      <!-- 基础信息 -->
      <el-row class="title_row">
        <el-col>
          <span class="title_class title_class_1">选手信息</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" v-for="(value, key) in userInfo" :key="key">
          <div class="basic-info">
            <span class="key">{{key}}：</span>{{value}}
          </div>
        </el-col>
      </el-row>
      <!-- 开通信息 -->
      <el-row class="title_row" style="margin-top: 15px;">
        <el-col>
          <span class="title_class title_class_1">开通信息</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8" v-for="(value, key) in openInfo" :key="key">
          <div class="basic-info">
            <span class="key">{{key}}：</span>{{value}}
          </div>
        </el-col>
      </el-row>
      <!-- 产品信息 -->
      <el-row class="title_row" style="margin-top: 15px;">
        <el-col>
          <span class="title_class title_class_1">产品信息</span>
        </el-col>
      </el-row>
      <div v-for="item of list" :key="item.id" style="width: 70%;">
        <el-row class="confirm-row" v-if="item.checked">
          <el-col :span="12">{{ item.tproductName }}</el-col>
          <el-col :span="6" style="text-align: center;">× {{ item.num }}</el-col>
          <el-col :span="6" style="text-align: right;">¥ {{ item.price }}</el-col>
        </el-row>
      </div>
      <div class="total" style="width: 70%;">费用合计：¥ {{ totalPrice }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openConfirm = false">取 消</el-button>
        <el-button type="primary" @click="doSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import areasData from '@/assets/area.json'
export default {
  data () {
    return {
      areasData: areasData.areas,
      area: null,
      dict_group: this.$userInfo.dict_group(),
      dict_grade: this.$userInfo.getGradeData(),
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }),
      order_source: this.$userInfo.orderSource(),
      order_status: [
        { value: '2', label: '待发货' },
        { value: '4', label: '无需发货，订单完成' }
      ],
      pay_way: [
        { value: 0, label: '微信支付' },
        { value: 1, label: '支付宝支付' },
        { value: 2, label: '对公转账' }
      ],
      userForm: {
        userName: '',
        phone: ''
      },
      userInfo: {},
      userId: '',
      isBasicInfoComplete: false,
      activityType: this.$chnEngStatusCode.activityType,
      productList: [],
      pForm: {
        productId: ''
      },
      list: [],
      totalPrice: 0,
      openConfirm: false,
      openForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        closeTime: '', // 订单完成时间
        endTime: '', // 支付时间
        orderTime: '', // 下单时间
        discountAmount: 0,
        orderAmount: '',
        paymentAmount: '',
        ip: '',
        orderSource: '',
        orderStatus: '', // 有地址-待发货。无地址-已完成
        payPlatform: 0, // 支付平台 0 微信支付 1 支付宝支付 2 公对公转账
        transactionId: '', // 交易流水号
        productDetailId: [],
        remark: '',
        nationalAddressDTO: {
          area: '',
          areaCode: 0,
          city: '',
          cityCode: 0,
          province: '',
          provinceCode: 0,
          receiptAddress: ''
        }
        // userId
        // productId
      },
      openFormRules: {
        closeTime: [{ required: true, message: '请选择', trigger: 'change' }],
        endTime: [{ required: true, message: '请选择', trigger: 'change' }],
        orderStatus: [{ required: true, message: '请选择', trigger: 'change' }],
        orderSource: [{ required: true, message: '请选择', trigger: 'change' }],
        orderTime: [{ required: true, message: '请选择', trigger: 'change' }],
        discountAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
        orderAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
        paymentAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
        ip: [{ required: true, message: '请输入', trigger: 'blur' }],
        transactionId: [{ required: true, message: '请输入', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      activeName: '0',
      needToSend: false,
      openInfo: {} // 确认弹窗展示信息
    }
  },
  created () {

  },
  methods: {
    goBack () {
      this.$router.back()
    },
    searchUser () {
      if (this.userForm.userName || this.userForm.phone) {
        this.$http.get('/erpUser/getSysUserInfo', { params: this.userForm }).then(resp => {
          if (resp.code === 200) {
            const userId = resp.data.userId
            this.userId = userId
            const userInfo = resp.data
            // 验证基础信息是否完善
            this.$http.get('/erpUser/verifyNationalShipUser', { params: { userId } }).then(res => {
              if (res.code === 200) {
                this.getProductList()
                const obj = {}
                obj['姓名'] = userInfo.userName
                obj['性别'] = userInfo.sex === '1' ? '女' : userInfo.sex === '2' ? '男' : '--'
                obj['手机号'] = userInfo.phone
                obj['邮箱'] = userInfo.email
                obj['证件类型'] = userInfo.cardType === '1' ? '身份证' : userInfo.cardType === '2' ? '护照' : '--'
                obj['证件号码'] = userInfo.idCard
                obj['国籍'] = userInfo.nationality
                obj['学校所在地'] = userInfo.province + userInfo.city + userInfo.area
                obj['学校名称'] = userInfo.schoolName
                obj['组别'] = this.getLevelLabel(userInfo.level)
                obj['年级'] = this.gradeFormatter(userInfo.grade)
                this.userInfo = obj
                this.isBasicInfoComplete = true
              }
            })
          }
        })
      }
    },
    getLevelLabel (level) {
      return level ? this.dict_group.find(item => item.dictCode === level).dictLabel : '--'
    },
    gradeFormatter (grade) {
      return grade ? this.dict_grade.find(item => item.dictCode === grade).dictLabel : '--'
    },
    reset () {
      this.$refs.userFormRef.resetFields()
      this.pForm.productId = ''
      this.isBasicInfoComplete = false
      this.userInfo = {}
      this.needToSend = false
    },
    onChange () {
      this.$http.get('/lexicon/getTbProductDetailList', { params: { productId: this.pForm.productId } }).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            item.checked = true
            item.num = 1
          })
          this.list = res.data
          this.calcTotalPrice()
        }
      })
    },
    getProductList () {
      this.$http.get('lexicon/getTbProductList', { params: { pageNum: 1, pageSize: 100, activityType: this.activityType } }).then(res => {
        this.productList = res.data
      })
    },
    checkChange () {
      this.calcTotalPrice()
    },
    numChange () {
      this.calcTotalPrice()
    },
    priceChange () {
      this.calcTotalPrice()
    },
    calcTotalPrice () {
      this.totalPrice = 0
      this.list.forEach(item => {
        if (item.checked) {
          this.totalPrice += Number(item.price) * item.num
        }
      })
      this.totalPrice = this.totalPrice.toFixed(2)
    },
    showOpenConfirm () {
      console.log(this.openForm)
      if (!this.openForm.productDetailId.length) {
        return this.$message.warning('请选择开通产品')
      }
      this.$refs.openFormRef.validate(valid => {
        if (!valid) return

        if (this.openForm.orderStatus === '2' && (!this.openForm.nationalAddressDTO.provinceCode || !this.openForm.nationalAddressDTO.receiptAddress)) {
          return this.$message.warning('请完善邮寄地址')
        }

        console.log(this.openForm)
        const obj = {}
        obj['赛季'] = this.openForm.season
        obj['订单来源'] = this.order_source.find(item => item.dictValue === this.openForm.orderSource).dictLabel
        obj['订单状态'] = this.order_status.find(item => item.value === this.openForm.orderStatus).label
        if (this.openForm.orderStatus === '2') {
          obj['邮寄省市区'] = this.openForm.nationalAddressDTO.province + this.openForm.nationalAddressDTO.city + this.openForm.nationalAddressDTO.area
          obj['详细地址'] = this.openForm.nationalAddressDTO.receiptAddress
        }
        obj['订单总额'] = this.openForm.orderAmount
        obj['实付金额'] = this.openForm.paymentAmount
        obj['优惠金额'] = this.openForm.discountAmount
        obj['下单时间'] = this.$moment(this.openForm.orderTime).format('YYYY-MM-DD HH:mm:ss')
        obj['支付时间'] = this.$moment(this.openForm.endTime).format('YYYY-MM-DD HH:mm:ss')
        obj['订单完成时间'] = this.$moment(this.openForm.closeTime).format('YYYY-MM-DD HH:mm:ss')
        obj['交易流水号'] = this.openForm.transactionId
        obj['IP地址'] = this.openForm.ip
        obj['备注'] = this.openForm.remark
        obj['支付方式'] = this.pay_way.find(item => item.value === this.openForm.payPlatform).label
        this.openInfo = obj
        this.openConfirm = true
      })
    },
    doSubmit () {
      this.openForm.orderTime = this.$moment(this.openForm.orderTime).format('YYYY-MM-DD HH:mm:ss')
      this.openForm.endTime = this.$moment(this.openForm.endTime).format('YYYY-MM-DD HH:mm:ss')
      this.openForm.closeTime = this.$moment(this.openForm.closeTime).format('YYYY-MM-DD HH:mm:ss')
      const data =
      {
        ...this.openForm,
        ...{
          userId: this.userId,
          productId: this.pForm.productId
        }
      }
      this.$http.post('/orderProduct/openErpTbOrderProduct', data).then(res => {
        if (res.code === 200) {
          this.openConfirm = false
          this.$confirm('开通成功，现在去查看订单？', '提示', {
            confirmButtonText: '查看订单',
            cancelButtonText: '留在本页，继续开通',
            type: 'warning'
          }).then(() => {
            this.$router.push('/product_Management/product_management')
          }).catch(() => {
            this.reset()
          })
        }
      })
    },
    handleClick () {
      if (this.activeName === '1') {
        if (this.list.length) {
          this.setNextPageInfo()
        }
      }
    },
    nextFn () {
      this.activeName = '1'
      this.setNextPageInfo()
    },
    setNextPageInfo () {
      this.openForm.orderAmount = this.totalPrice
      this.openForm.paymentAmount = this.totalPrice
      const arr = this.list.filter(item => item.checked)
      this.needToSend = !!arr.find(item => item.handType === 2)
      this.openForm.orderStatus = this.needToSend ? '2' : '4'
      this.openForm.productDetailId = arr
    },
    prevFn () {
      this.activeName = '0'
    },
    // 省市区选择
    provincesHandleChange (value) {
      console.log('value', value)
      this.openForm.nationalAddressDTO.provinceCode = this.area[0]
      this.openForm.nationalAddressDTO.cityCode = this.area[1]
      this.openForm.nationalAddressDTO.areaCode = this.area[2]
      const deliveryAreaName = this.$refs.areaRef.getCheckedNodes()[0].pathLabels.join('/')
      const areaList = deliveryAreaName.split('/')
      this.openForm.nationalAddressDTO.province = areaList[0]
      this.openForm.nationalAddressDTO.city = areaList[1]
      this.openForm.nationalAddressDTO.area = areaList[2]
    }
  }

}
</script>
<style scoped lang="less">
.basic-info{
  font-size: 14px;
  color: #606266;
  margin-bottom: 12px;
  .key{
    font-weight: bold;
  }
}
.key{
  width: 100px;
  display: inline-block;
  text-align: right;
}
.list-item{
  // border-bottom: 1px dashed #dadada;
  // height: 60px;
  // padding-bottom: 12px;
  margin-bottom: 12x;
  font-size: 14px;
  margin-left: 50px;
  padding: 8px 16px;
  &:hover{
    background-color: #F0F8FF;
  }
}
.list-item-checkbox{
  height: 32px;
  line-height: 32px;
}
.price-input{
  width: 80px;
  height: 32px;
  /deep/ input.el-input__inner{
    height: 32px;
  }
}
.price-num{
  width: 110px;
}
.list-item-price{
  text-align: right;
}
.thead{
  font-size: 14px;
  font-weight: bold;
  color: #606266;
  line-height: 40px;
}
.total{
  text-align: right;
  color: rgb(64, 158, 255);
  font-size: 18px;
  margin-top: 24px;
}
.default{
  text-align: center;
  font-size: 14px;
  color: #909399;
  margin-top: 40px;
  margin-bottom: 40px;
}
.submit{
  text-align: center;
  padding-top: 20px;
  .btn{
    width: 120px;
  }
}
.title_class_1{
  font-size: 16px;
  color: #303133;
}
.confirm-row {
  border-bottom: 1px dashed #dadada;
  padding-bottom: 8px;
  margin-bottom: 8px;
}
</style>
